// Run before application modules so production startup logs are also silenced.
if (process.env.NODE_ENV === 'production') {
  ['log', 'debug', 'info', 'warn', 'error', 'trace', 'table', 'group',
    'groupCollapsed', 'groupEnd', 'dir', 'dirxml', 'assert', 'count',
    'countReset', 'time', 'timeLog', 'timeEnd'].forEach(method => {
    console[method] = () => {};
  });
}
